import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../security/authentication.service';

@Component({
    templateUrl: './login.component.html'
})
export class LoginComponent {
    public user: any = {};
    public submitting: boolean = false;
    public errorMessage: string = "";

    constructor(private authenticationService : AuthenticationService, private route: ActivatedRoute, private router: Router, ) {}

    submit(): void {
        this.submitting = true;
        let returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        this.authenticationService
            .signinByUsernamePassword(this.user.username, this.user.password)
            .subscribe(
                response => {
                    let responseData: any = response['data'] ;
                    //
                    var now = new Date();
                    now.setSeconds(now.getSeconds() + responseData.expires_in);
                    //
                    let userInfo = {
                        username: this.user.username,
                        accessToken: responseData.access_token,
                        refreshToken: responseData.refresh_token,
                        scope: responseData.scope,
                        expiresIn: now.getTime()       
                    };
                    localStorage.setItem("ls.userInfo", JSON.stringify(userInfo));
                    if(returnUrl.indexOf('http://') == 0 || returnUrl.indexOf('https://') == 0) {
                        window.location.href = returnUrl;
                    } else {
                        this.router.navigateByUrl(returnUrl);
                    }
                },
                (error) => {
                    if (error.error instanceof Error) {
                        // A client-side or network error occurred. Handle it accordingly.
                        this.errorMessage = error.error.message;
                    } else {
                        // The backend returned an unsuccessful response code.
                        // The response body may contain clues as to what went wrong,
                        this.errorMessage = 'Error ' + error.status + ' (' + error.statusText + ')' + (error.error ? ':' + error.error.data.error_description : '');
                    }
                    this.submitting = false;
                }
            );
    }
}



// WEBPACK FOOTER //
// /Users/Anders/workspace/DOFBasenCli/src/app/share/login/login.component.ts